/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Due-date filter buckets for the ticket list. NOTE: the real SLA thresholds
 * (business-day response/fix times by severity) are defined by issue #2; issue #1
 * computes buckets from placeholder constants. See
 * !:Compliance.Module.Support.Services.SupportSeverity / the controller TODO.
 */
export enum DueDateBucket {
    ALL = 'All',
    OPEN = 'Open',
    DUE_SOON = 'DueSoon',
    OVERDUE = 'Overdue',
}
